<div class="item">
    <h3 class="h5">{{item?.orc}}</h3>
    <div>{{item?.displayName}}</div>
    <div class="last-edited">
        <span>{{item?.updatedBy}}</span>
        <span>{{item?.updatedDate | date}}</span>
    </div>
</div>